/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */

import { z } from 'zod'
import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'
import { LeadNoteType } from 'types/enums/LeadNoteType'

export const useLeadNoteSchema = () => {
    const { t } = useTranslation()

    return useMemo(() => z.object({
        content: z
            .string()
            .trim()
            .min(1, t('Content is required'))
            .max(2000, t('Content must be at most 2000 characters')),
        type: z.nativeEnum(LeadNoteType, {
            message: t('Select a valid task type'),
        }),
    }), [t])
}

export type LeadNoteInputs = z.infer<ReturnType<typeof useLeadNoteSchema>>
